import { useState } from "react";
import { Box } from "@mui/material";
import { EvaluationSectionCard } from "./EvaluationSectionCard";
import {
  AnswerDetail,
  CategoryDetail,
  SingleEvaluationQuestions,
} from "../../Models/evaluation";

export interface SectionWithKey {
  key: string;
  category: CategoryDetail;
}

export interface EvaluationSectionsListProps {
  sections: SectionWithKey[];
  questions: SingleEvaluationQuestions[];
  answers: AnswerDetail[];
  onSaveFeedback: (
    sectionId: string,
    responses: Record<string, string>
  ) => void;
}

export function EvaluationSectionsList({
  sections,
  questions,
  answers,
  onSaveFeedback,
}: EvaluationSectionsListProps) {
  const [expandedSections, setExpandedSections] = useState<Set<string>>(
    new Set()
  );

  const handleToggleSection = (sectionKey: string) => {
    setExpandedSections((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(sectionKey)) {
        newSet.delete(sectionKey);
      } else {
        newSet.add(sectionKey);
      }
      return newSet;
    });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      {sections.map(({ key, category }) => {
        return (
          <EvaluationSectionCard
            key={key}
            sectionKey={key}
            section={category}
            isExpanded={expandedSections.has(key)}
            questions={questions}
            answers={answers}
            onToggleExpand={() => handleToggleSection(key)}
            onSaveFeedback={onSaveFeedback}
          />
        );
      })}
    </Box>
  );
}
